export function extractParams(params: any) {
  return {
    userId: 1,
    day: 0,
    month: new Date().getMonth() + 1,
    year: new Date().getFullYear(),
    hdPPMRepairAll: params.hdPPMRepairAll && parseInt(params.hdPPMRepairAll.value.value) ? parseInt(params.hdPPMRepairAll.value.value) : 2,
    hdPPMRepairAllTitle: params.hdPPMRepairAll && params.hdPPMRepairAll.value.title,
    category: params.hdCategory && parseInt(params.hdCategory.value.value),
    categoryTitle: params.hdCategory && params.hdCategory.value.title,
    jobCategory: params.hdJobCategory && parseInt(params.hdJobCategory.value.value),
    jobCategoryTitle: params.hdJobCategory && params.hdJobCategory.value.title,
    contractor: params.hdContractor && parseInt(params.hdContractor.value.value) ? parseInt(params.hdContractor.value.value) : 0,
    contractorTitle: params.hdContractor && params.hdContractor.value.title || "",
    hdStatus: params.hdStatus && params.hdStatus.value.value,
    hdStatusTitle: params.hdStatus && params.hdStatus.value.title,
    usecategory: 0,
    status: 1,
  }
}

export function getTitle(params: any) {
  const p = extractParams(params)
  const title: string[] = []

  if (p.hdPPMRepairAllTitle) {
    title.push(`Type: ${p.hdPPMRepairAllTitle}`)
  }
  if (p.category === 0) {
    title.push(`Category: ${p.categoryTitle}`)
  } else if (p.categoryTitle !== undefined) {
    title.push(`Category: ${p.categoryTitle} [${p.category}]`)
  }
  if (p.jobCategory === 0) {
    title.push(`Category: ${p.jobCategoryTitle}`)
  } else if (p.jobCategoryTitle !== undefined) {
    title.push(`Category: ${p.jobCategoryTitle} [${p.jobCategory}]`)
  }
  if (p.contractorTitle) {
    title.push(`Contractor: ${p.contractorTitle} [${p.contractor}]`)
  }
  if (p.hdStatusTitle) {
    title.push(`Status: ${p.hdStatus.value.title}`)
  }
  return title.join(", ")
}

export const statusMap: Map<string, number> = new Map([
  ["In-Progress", 0], // In-Progress == Outstanding
  ["Outstanding", 0],
  ["Completed", 1],
  ["Cancelled", 2],
  ["Failed", 3],
  ["Supressed", 4],
])
